import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { UserRequest, UserModel } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../services/error-handler.service';

@Injectable({ providedIn: 'root' })
export class AuthService {

  public token: string;
  jwtHelper = new JwtHelperService();
  tokenIdentifier = 'id_token';
  currentPageLogin = false;

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
    this.token = localStorage.getItem('tokenId');
  }

  isAuthenticated() {
    return !this.jwtHelper.isTokenExpired(this.token);
  }

  getAuthorizationHeader(): string {
    return this.token ? this.token : '';
  }

  signIn(userInfo: UserRequest.Login): Observable<UserModel> {

    const url = environment.auth0.loginUrl;

    const body = {
      client_id: environment.auth0.clientID,
      audience: environment.auth0.audience,
      realm: environment.auth0.realm,
      grant_type: environment.auth0.grant_type,
      username: userInfo.email,
      password: userInfo.password,
      scope: 'openid profile email',
    };

    return this.http.post<HttpResponse<any>>(url, body, {headers: {'Content-Type': 'application/json'} }).pipe(
      map((authResult) => {
        if (authResult && authResult[this.tokenIdentifier]) {
          const token = authResult[this.tokenIdentifier];
          localStorage.setItem('tokenId', token);
          this.token = token;
          const decodedJson = this.jwtHelper.decodeToken(authResult[this.tokenIdentifier]);
          // Todo: Save user info.
          return decodedJson.email;
        }
      }));
  }

  logout(): void {

    const url = window.location.protocol + '//' + window.location.hostname;
    const port = window.location.port.length > 0 ? ':' + window.location.port : '';
    const redirectUrl = encodeURIComponent(url) + port;
    window.location.href = environment.auth0.logoutUrl + redirectUrl + '/&client_id=' + environment.auth0.clientID;
    // Clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('tokenId');
  }

}
